var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncomingVertical = function SvgIncomingVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11v9c0 1.1-.9 2-2 2H5.02c-1.1 0-2-.9-2-2v-9.02C3.02 9.89 3.91 9 5 9h3.01c.55 0 1 .45 1 1s-.45 1-1 1H5.99c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12.03c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1h-2.01c-.55 0-1-.45-1-1s.45-1 1-1H19c1.1 0 2 .9 2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.402 16.85 2.79-2.79a.5.5 0 0 0-.36-.85h-1.79v-9c0-.55-.45-1-1-1s-1 .45-1 1v9h-1.79c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0"
  })));
};
export default SvgIncomingVertical;